import React, { useState } from 'react';
import { Button, Drawer, Space } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useNarrowScreen } from '../hooks/useNarrowScreen';

type Props = {
  children: React.ReactNode;
  /** fragment：桌面不包一层；space：桌面仍是一行可换行的筛选。 */
  variant?: 'fragment' | 'space';
  style?: React.CSSProperties;
  /** 窄屏用两列短面板，避免筛选项拉成一长条。 */
  dense?: boolean;
};

/**
 * 窄屏把筛选项收进底部抽屉。桌面按 variant 原样排布，确定/重置仍走原来的点击。
 */
const FilterDrawer: React.FC<Props> = ({ children, variant = 'fragment', style, dense = false }) => {
  const narrow = useNarrowScreen();
  const [open, setOpen] = useState(false);

  if (!narrow) {
    if (variant === 'space') {
      return <Space wrap style={style}>{children}</Space>;
    }
    return <>{children}</>;
  }

  return (
    <>
      <Button
        icon={<FilterOutlined />}
        onClick={() => setOpen(true)}
        style={{ minHeight: 40, marginBottom: 12 }}
      >
        筛选
      </Button>
      <Drawer
        title="筛选"
        placement="bottom"
        height={dense ? 'auto' : '80%'}
        open={open}
        onClose={() => setOpen(false)}
        destroyOnClose={false}
        styles={dense ? { body: { padding: 12 } } : undefined}
      >
        <div
          className={dense ? 'kfc-filter-stack kfc-filter-dense' : 'kfc-filter-stack'}
          onClick={(e) => {
            const btn = (e.target as HTMLElement).closest('button');
            if (!btn) return;
            if (btn.closest('.ant-select, .ant-picker, .ant-dropdown, .ant-input-clear-icon, .ant-select-clear, .ant-picker-clear')) return;
            setOpen(false);
          }}
        >
          {children}
        </div>
      </Drawer>
    </>
  );
};

export default FilterDrawer;
